import React, { Children, cloneElement, isValidElement } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const Wrapper = styled.div`
  .react-resizable-handle-se {
    transform: unset !important;
    bottom: 6px !important;
    right: 6px !important;
    height: 7px;
    border-radius: 50%;
    width: 7px;
    background: unset;
    background-color: ${p => p.theme.colors.theme};
    &:after {
      content: none !important;
    }
  }
`;

const TileWrapper = React.forwardRef((
  { children, stateProps = [], reducerKey = '', ...rest },
  ref,
) => {
  const props = useSelector(state => state[reducerKey]);
  const childProps = stateProps.reduce((tot, curr) => {
    if (props[curr]) {
      return {
        ...tot,
        [curr]: props[curr],
      };
    }
    return tot;
  }, {});

  const childrenWithProps = Children?.map(children, (child) => {
    if (isValidElement(child)) {
      return cloneElement(child, childProps);
    }
    return child;
  });

  return (
    <Wrapper {...rest} ref={ref}>{childrenWithProps}</Wrapper>
  );
});

TileWrapper.propTypes = {
  children: PropTypes.object,
  stateProps: PropTypes.array,
  reducerKey: PropTypes.string,
};

export default TileWrapper;
